import { REG_ACTION_PARAM } from './_constants';
/**
 * Tests the value against the regular expression
 * @param {any} expression The regular expression
 * @param {any} value The value to test
 */

export var testRegex = function testRegex(expression, value) {
  var regex;

  try {
    regex = new RegExp(expression);
    return regex.test(value);
  } catch (_unused) {
    return false;
  }
};
/**
 * Raises an analytics event for newsletter CTA subscription.
 * @param {string} eventName The name of the analytics event.
 * @param {Newsletter} newsletter The newsletter object.
 * @param {string} location The location within the page where the subscription occurred.
 */

export var raiseNewsletterAnalyticsEvent = function raiseNewsletterAnalyticsEvent(eventName, newsletter, location, sourceCode) {
  if (eventName && newsletter) {
    var analyticsEvent = {
      EventType: eventName,
      NewsletterTitle: [newsletter.name],
      NewsletterId: [newsletter.listId]
    };
    if (sourceCode && sourceCode != 0) analyticsEvent.ESRC_CAS = sourceCode;
    var regAction = new URLSearchParams(window.location.search).get(REG_ACTION_PARAM);

    if (regAction) {
      analyticsEvent.RegAction = regAction;
    }

    if (location) {
      analyticsEvent.SubscriberPosition = location;
    }

    GeneralMills.Analytics && GeneralMills.Analytics.raiseEvent(analyticsEvent);
  }
};
/**
 * Adds a query string parameter for email to the provided registration URL.
 * @param {string} regUrl The registration URL.
 * @param {string} email The email address for the query string parameter.
 * @returns {string} The updated registration URL.
 */

export var getRegUrlWithEmailParam = function getRegUrlWithEmailParam(regUrl, email) {
  if (regUrl && email) {
    var separator = regUrl.indexOf('?') > -1 ? '&' : '?';
    return regUrl + separator + 'email=' + encodeURIComponent(email);
  }

  return regUrl;
};